import { ca } from '@cian/analytics';

import { EImageType } from '../../../../../../types/offer';
import { transformOfferImageType } from '../../../../../../mappers/analytics';

interface ITrackOpenFullscreenGallery {
  imageType: EImageType;
  offerId: number;
}

export function trackOpenFullscreenGallery({ imageType, offerId }: ITrackOpenFullscreenGallery) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'open_fullscreen_gallery',
    label: transformOfferImageType({ imageType }),
    products: [{ id: offerId, offerType: 'offer' }],
  });
}

interface ITrackCloseFullscreenGallery {
  offerId: number;
}

export function trackCloseFullscreenGallery({ offerId }: ITrackCloseFullscreenGallery) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'Compare',
    action: 'close_fullscreen_gallery',
    products: [{ id: offerId, offerType: 'offer' }],
  });
}
